<template>
  <div 
    class="relative cursor-default" 
    :class="{'cursor-pointer': !disabled_pass && !disabled,
             'disabled || disabled_pass' : disabled_pass || disabled,
             'pt-2.5': alignWithoutLibelle!=null && alignWithoutLibelle,
             'xl:pt-7 xxl:pt-8 2xl:pt-10': alignWithoutLibelle==null || !alignWithoutLibelle}"
    @click="activeCheckbox"
    @mouseover="tooltip=true;"
    @mouseleave="tooltip=false;"
  >   
    <transition 
      enter-active-class="duration-300 delay-1000"
      enter-class="opacity-0"
      enter-to-class="opacity-100"
      leave-active-class="duration-300"
      leave-class="opacity-100"
      leave-to-class="opacity-0"
    >
      <div
        v-if="tooltip && label != null" 
        class="absolute rounded-lg shadow-lg bg-indigo-600 text-white bottom-8 right-10 z-30 p-2 text-sm w-max-content w-max max-w-128"
      >
        {{ label }}
      </div>
    </transition>
    <span 
      class="rounded-md border-2 border-pink-300 text-center text-sm transition-all duration-200
              px-3 py-2.5 xxl:px-3.5 xxl:py-3 2xl:px-4 2xl:py-3.5" 
      :class="{'text-white bg-pink-600': mutableValue, 
               'bg-pink-100 text-gray-900': !mutableValue,}"
    >
      {{ libelle }}
    </span>
    <input
      type="hidden" 
      :name="name" 
      v-model="mutableValue" 
    >
  </div>
</template>

<script>

export default {
  props: ['name', 'libelle', 'value', 'disabled', 'label', 'alignWithoutLibelle'],
  data: function () {
    return {
      tooltip: false,
      mutableValue: this.value,
      disabled_pass: false,
    };
  }, 
  mounted(){
    // Manage edit permission for neopass pages
    if(this.$route.path.includes('form/neopass')){
      let idpass = this.$route.path.split('/form/neopass/')[1].split('/')[0];
      let page = this.$route.path.split('/form/neopass/')[1].split('/')[2];
      if(this.$can(page+'_edit', idpass)){
        this.disabled_pass = false;
      }
      else{
        this.disabled_pass =  true;
      }
    }else{
      this.disabled_pass = false;
    }
  },
  methods:{
    activeCheckbox(){
      if(!this.disabled_pass && !this.disabled){
        if(!this.mutableValue){
          this.mutableValue = true;
        }else if(this.mutableValue){
          this.mutableValue = false;
        }else{
          this.mutableValue = true;
        }
      }
    }
  },
  watch: {
    mutableValue() {
      this.$emit('input', this.mutableValue);
    },
    value(){
      this.mutableValue = this.value;
    }
  }
};
</script>